import Kiosk from '@/components/Kiosk/Kiosk.vue';
import EmbeddedKiosk from '@/Core.Service.Domain/ViewSupport/Kiosk/Components/Kiosk.vue';

const routesList = [];

const KioskRoute = {
  path: '/report/:id/:loadTimer?/:kiosk',
  name: 'Kiosk',
  component: Kiosk,
  meta: {
    allowAnonymous: true,
  },
};

const EmbeddedKioskRoute = {
  path: '/report-embedded-kiosk/:id',
  name: 'EmbeddedKiosk',
  components: {
    EmbeddedKiosk: EmbeddedKiosk,
  },
  meta: {
    allowAnonymous: true,
    showAppBar: false,
    isEmbeddedKiosk: true,
  },
};

routesList.push(KioskRoute, EmbeddedKioskRoute);

export default routesList;
